module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-16-32c3b15c1a2286188ce8f798e765f38d.jpg";